export default __webpack_public_path__ + "static/media/brown-connie-i-lov-u.43068867.png";